import fetch from '../utils/fetch'

export function searchAPI(data) {
    return fetch({
        url:  '/news/search',
        method: "get",
        params: data,
    })
}

export function queryAPI(data) {
    return fetch({
        url:  '/news/search/detail',
        method: "get",
        params: data,
    })
}
